export function elevenDigitsIfSpecified(value) {
  const isValid = value === null || /^(\d{11}|)$/.test(value);
  return {
    valid: isValid,
    errorMessage: 'Bitte überprüfen Sie die Eingabe Ihrer 11-stelligen Marktlokations-ID.',
  }
}
